/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Anvermoegenswirksameleitungen2Inputs */



/**

* @param {_Field_Anvermoegenswirksameleitungen2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_anvermoegenswirksameleitungen2 = /** @type {((inputs?: _Field_Anvermoegenswirksameleitungen2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Anvermoegenswirksameleitungen2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Vermoegenswirksame Leitungen")
});
export { _field_anvermoegenswirksameleitungen2 as "_field_anVermoegenswirksameLeitungen" }